import { render, staticRenderFns } from "./dictNextManage.vue?vue&type=template&id=797eed29&scoped=true&"
import script from "./dictNextManage.vue?vue&type=script&lang=js&"
export * from "./dictNextManage.vue?vue&type=script&lang=js&"
import style0 from "./dictNextManage.vue?vue&type=style&index=0&id=797eed29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797eed29",
  null
  
)

export default component.exports